export const EMBED_IMAGE_CLASS = 'war-room-post-text__embed-image';
export const EMBED_IMAGE_DELETE_BUTTON_CLASS = 'war-room-post-text__embed-image-delete-btn';
export const EMBED_IMAGE_CONTAINER_CLASS = 'war-room-post-text__embed-image-container';
export const EMBED_IMAGE_LOADER_CLASS = 'war-room-post-text__embed-image-loader';
export const EMBED_IMAGE_LOADER_ANIMATION_CLASS = 'war-room-post-text__embed-image-loader-animation';
